import { render, staticRenderFns } from "./LocalityForm.vue?vue&type=template&id=1d44b815&scoped=true"
import script from "./LocalityForm.vue?vue&type=script&lang=js"
export * from "./LocalityForm.vue?vue&type=script&lang=js"
import style0 from "./LocalityForm.vue?vue&type=style&index=0&id=1d44b815&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d44b815",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d44b815')) {
      api.createRecord('1d44b815', component.options)
    } else {
      api.reload('1d44b815', component.options)
    }
    module.hot.accept("./LocalityForm.vue?vue&type=template&id=1d44b815&scoped=true", function () {
      api.rerender('1d44b815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/detail/components/LocalityForm.vue"
export default component.exports